import React from 'react';

import '@app/scss/components/richText.scss';
import '@app/scss/components/customMarkup.scss';

interface CustomMarkupProps {
	text: string;
	alt?: object;
}

const CustomMarkup: React.FC<CustomMarkupProps> = ({ text, alt }) => {
	let index = -1;

	const [arrayText, setArrayText] = React.useState(text?.split('<'));
	const [newText, setNewText] = React.useState('');

	React.useEffect(() => {
		if (alt) {
			text.split('<').map((value, i) => {
				if (value.indexOf('img') > -1) {
					index = i;
				}
			});

			if (index > -1) {
				arrayText[index] = `${arrayText[index].substr(0, 3)} alt="${alt}" ${arrayText[index].substr(4, arrayText[index].length)}`;
				setNewText(arrayText.join('<'));
			}
		}
	}, [alt]);

	return <div dangerouslySetInnerHTML={{ __html: newText.length ? newText : text }} />;
};

export default CustomMarkup;
